import {
  ComcastErrorType,
  triggerSentryError,
} from '../../../../shared/helpers'

import type { Season, Video } from '../../reducers/types/reducerTypes'
import type { VideoSection } from './types'

export const handleSeasonDetailsError = ({ error, url }) => {
  const errorDescription = `Error ${
    error.status ? error.status : '(unknown)'
  } on GA Seasons screen checking for Season Details on ${url}`

  triggerSentryError('getSeasonDetails', 'SeasonsScreen/utils.ts', {
    errorMessage: error.message ?? 'Undefined error message (default)',
    errorDescription,
    errorLocation: 'SeasonsScreen - useSeasonContent - getSeasonDetails',
    errorType: ComcastErrorType.network,
  })
}

export const handleExtrasInSeasonsError = ({ error, url }) => {
  const errorDescription = `Error ${
    error.status ? error.status : '(unknown)'
  } on GA Seasons screen checking for Season Extras on ${url}`

  triggerSentryError('getExtrasInSeasons', 'SeasonsScreen/utils.ts', {
    errorMessage: error.message ?? 'Undefined error message (default)',
    errorDescription,
    errorLocation: 'SeasonsScreen - useSeasonContent - getExtrasInSeasons',
    errorType: ComcastErrorType.network,
  })
}

export const handlePaginatedEpisodesError = ({ error, url }) => {
  const errorDescription = `Error ${
    error.status ? error.status : '(unknown)'
  } on GA Seasons screen checking for Season Episodes on ${url}`

  triggerSentryError('getPaginatedEpisodes', 'SeasonsScreen/utils.ts', {
    errorMessage: error.message ?? 'Undefined error message (default)',
    errorDescription,
    errorLocation: 'SeasonsScreen - useSeasonContent - getPaginatedEpisodes',
    errorType: ComcastErrorType.network,
  })
}

export const getSection = (
  seasonTitle: string,
  activeSeason: Season | undefined,
  videos: Video[] = []
): VideoSection => ({
  seasonOrdinal: activeSeason?.ordinal,
  key: `${seasonTitle}-${activeSeason?.cid}`,
  title: seasonTitle,
  videos,
})

const getVideoSectionTTS = (videoSection: VideoSection) =>
  `${videoSection.videos.length} ${videoSection.title}`

export const getSeasonFullTTS = (videoSections: VideoSection[]) => {
  let text = ''
  if (videoSections.length === 2) {
    const sectionOne = videoSections[0]
    const sectionTwo = videoSections[1]

    if (sectionOne.videos.length > 0 && sectionTwo.videos.length > 0) {
      text = `${getVideoSectionTTS(sectionOne)} and ${getVideoSectionTTS(
        sectionTwo
      )}`
    } else if (sectionOne.videos.length > 0 && sectionTwo.videos.length === 0) {
      text = getVideoSectionTTS(sectionOne)
    } else if (sectionOne.videos.length === 0 && sectionTwo.videos.length > 0) {
      text = getVideoSectionTTS(sectionTwo)
    }
  } else if (videoSections.length === 1 && videoSections[0].videos.length > 0) {
    text = getVideoSectionTTS(videoSections[0])
  }

  return text
}
